module.exports = __webpack_public_path__ + "static/img/38.f1eb4c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/38.png
// module id = UdhG
// module chunks = 1